'use client';
const IDENT_POPOVER_TARGET = 'PopoverTarget';
const targetDefaultProps = {
    refProp: 'ref',
    popupType: 'dialog'
};

export { IDENT_POPOVER_TARGET, targetDefaultProps };
//# sourceMappingURL=PopoverTarget.contract.js.map
